import { LabelHTMLAttributes, PropsWithChildren } from 'react';

import { cn } from '@/utils';

interface LabelFieldProps extends LabelHTMLAttributes<HTMLLabelElement> {
  className?: string;
}

const Label = ({
  children,
  className,
  ...rest
}: PropsWithChildren<LabelFieldProps>) => {
  return (
    <label
      className={cn('block text-sm text-gdt-gray font-bold', className)}
      {...rest}
    >
      {children}
    </label>
  );
};

export default Label;
